import styled from 'styled-components'

import colors from 'styles/colors'

export const Divider = () => <DividerContent />

const DividerContent = styled.div`
    background: ${colors.platinumGray};
    height: 0.1rem;
    width: 100%;
    margin: 1.4rem auto;
`
